import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as admin from '../../../../admin'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When page is selected or marked for editing, put it's variables to editing
 * state.
 */
export const syncPageVariablesForEditing = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    pageEc: Collection,
    editingVariablesFeature: admin.editingVariables.Feature,
  ) =>
    pageEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asObservable.pipe(
        rxjs.map(page =>
          page
            ? editingVariablesFeature.actions.putInitialDefinitions
                .from('syncPageVariablesForEditing (effect)')
                .create(page.variables ?? [])
            : editingVariablesFeature.actions.reset
                .from('syncPageVariablesForEditing (effect)')
                .create(),
        ),
      ),
)
